import { gql } from '@apollo/client'

const getPublicCategoryQuery = gql`
  query GetPublicCategory($slug: String!, $marketId: ID!) {
    market(id: $marketId) {
      category(slug: $slug) {
        id
        slug
        title
        cmsItems {
          id
          type
          content
          ... on PublicCmsItemBlogPost {
            slug
            image {
              url
            }
            excerpt
          }
        }
      }
    }
  }
`

export const PREFETCH_PUBLIC_CATEGORY = gql`
  query PrefetchPublicCategory($slug: String!, $marketId: ID!) {
    market(id: $marketId) {
      category(slug: $slug) {
        id
        slug
        title
        cmsItems {
          id
          type
          content
          ... on PublicCmsItemBlogPost {
            slug
            image {
              url
            }
            excerpt
          }
        }
      }
    }
  }
`

export default getPublicCategoryQuery
